export default __webpack_public_path__ + "static/media/flag-australia.a6e4ecd7.png";